import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { FontAwesomeIcon } from 'atoms/icons';
import { Tooltip } from 'atoms/tooltip/Tooltip';
import { LabelM } from 'atoms/typography';
import { tabletAndAbove } from 'style/mediaQuery';

const ButtonLabel = styled.span`
  margin-left: var(--unit);
  display: none;
`;

const ButtonWithHiddenLabel = styled(Button)`
  min-width: 100px !important;
  border: 1px solid var(--c-nd-800);

  @media ${tabletAndAbove} {
    width: auto;
    ${ButtonLabel} {
      display: block;
    }
  }
`;

type Props = {
  reason: string | null;
};

export const CompletedCta = ({ reason }: Props) => {
  return (
    <Tooltip
      leaveTouchDelay={3000}
      title={<LabelM>{reason}</LabelM>}
      placement="top"
    >
      <ButtonWithHiddenLabel
        fullWidth
        disabled
        color="quaternary"
        size="medium"
      >
        <FontAwesomeIcon icon={faCircleCheck} />
        <ButtonLabel>
          <FormattedMessage
            id="LobbyCompetitionListCta.completed"
            defaultMessage="Completed"
          />
        </ButtonLabel>
      </ButtonWithHiddenLabel>
    </Tooltip>
  );
};
